import Managers from './containers/Managers';

import { managersSelectors, ManagersState } from './services/selectors';
import epics from './services/epics';
import reducer from './services/reducer';

export { managersSelectors, epics, ManagersState, reducer };

export default Managers;



// WEBPACK FOOTER //
// ./src/scenes/Managers/index.ts